import { z } from "zod";
import { BudgetExcess } from "./budgets.js";

/** Machine-readable error codes of the CloudServer API (SPEC §7.3). */
export const ErrorCode = z.enum([
  "validation_failed",
  "unauthorized",
  "forbidden",
  "not_found",
  "conflict",
  "protected",
  "limit_exceeded",
  "rate_limited",
  "provider_unavailable",
  "provider_rejected",
  "internal",
]);
export type ErrorCode = z.infer<typeof ErrorCode>;

/** One invalid input field, pointed to by its path in the request body or query. */
export const FieldError = z.object({
  path: z.array(z.union([z.string(), z.number()])),
  message: z.string(),
  /** Stable key the UI translates (`errors.reasons.<reason>`); `message` is English for logs and tools. */
  reason: z.string().optional(),
});
export type FieldError = z.infer<typeof FieldError>;

/** RFC 9457 problem details, extended with our code and the request id. */
export const Problem = z.object({
  type: z.string(),
  title: z.string(),
  status: z.number().int().min(400).max(599),
  detail: z.string().optional(),
  code: ErrorCode,
  /** Stable key of the specific cause, translated by the UI; absent for generic errors. */
  reason: z.string().optional(),
  requestId: z.string(),
  fields: z.array(FieldError).optional(),
  /** `budget_exceeded`: how far the change would take the month's forecast over the budget. */
  budget: BudgetExcess.optional(),
});
export type Problem = z.infer<typeof Problem>;
